import { useLanguage } from '../lib/i18n/LanguageContext';

/**
 * Shared initial-load spinner (Uiverse.io / alexruix big-octopus-60).
 * Use for page/section fetches; prefer this over skeleton rows/cards.
 */
export function PageLoader({ compact = false }: { compact?: boolean }) {
  const { dict } = useLanguage();
  return (
    <div
      className={`page-loader${compact ? ' page-loader--compact' : ''}`}
      role="status"
      aria-live="polite"
      aria-label={dict.common.loading}
    >
      <div className="loader" aria-hidden="true">
        <p className="loader-text">loading</p>
        <span className="load" />
      </div>
    </div>
  );
}
